import { Button } from '../../atoms/button/button';
import { Header } from '../../atoms/header/header';
import { BackLink } from '../../molecules/back-link/back-link';

import passwordChangeSuccess from './assets/password-change-success.svg';

type ChangePasswordSuccessPageProps = {
  readonly onBack: () => void;
  readonly onDone: () => void;
  readonly backText: string;
  readonly title: string;
  readonly buttonText: string;
};

function ChangePasswordSuccessPage({ onBack, onDone, backText, title, buttonText }: ChangePasswordSuccessPageProps) {
  return (
    <div className="relative flex justify-center">
      <div className="max-w-[680px] w-full mx-auto h-full pt-0 p-6">
        <div className="mb-6">
          <BackLink onBack={onBack} text={backText} />
        </div>
        <div className="flex flex-col gap-[30px]">
          <Header level="h2">{title}</Header>
          <img alt="Success illustration" className="w-full h-auto mx-auto" src={passwordChangeSuccess} />
          <Button className="w-full" onClick={onDone}>
            {buttonText}
          </Button>
        </div>
      </div>
    </div>
  );
}

ChangePasswordSuccessPage.displayName = 'ChangePasswordSuccessPage';

export { ChangePasswordSuccessPage };
export type { ChangePasswordSuccessPageProps };
